import { render } from "./TwoMapsManager.vue?vue&type=template&id=822e1434&scoped=true"
import script from "./TwoMapsManager.vue?vue&type=script&lang=js"
export * from "./TwoMapsManager.vue?vue&type=script&lang=js"

import "./TwoMapsManager.vue?vue&type=style&index=0&id=822e1434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822e1434"]])

export default __exports__